import { MILLISECONDS_PER_HOUR } from "@shared-kernel/core/constants/time.constants";
import type { ApiTrainingSchedule } from "@shared-kernel/core/types/api-training-schedule";

export const computeTotalScheduleHours = (schedules: ApiTrainingSchedule[]): number => {
  return schedules.reduce((total, schedule) => {
    let hours = 0;
    if (schedule.morning.enabled) {
      hours += (new Date(schedule.morning.end).getTime() - new Date(schedule.morning.start).getTime()) / MILLISECONDS_PER_HOUR;
    }
    if (schedule.afternoon.enabled) {
      hours += (new Date(schedule.afternoon.end).getTime() - new Date(schedule.afternoon.start).getTime()) / MILLISECONDS_PER_HOUR;
    }
    return total + hours;
  }, 0);
};
